import { PRODUCT_GROUP_TRANSLATIONS } from "../action-types/product-group-translations";

const initialState = {
  loading: false,
  productGroupTranslations: [],
  error: '',
};

export default function (state = initialState, action) {
  switch (action.type) {
    case PRODUCT_GROUP_TRANSLATIONS.REQUEST:
      return {
        ...state,
        loading: true,
      };
    case PRODUCT_GROUP_TRANSLATIONS.SUCCESS:
      return {
        ...state,
        productGroupTranslations: action.payload.data,
        loading: false,
      };
    case PRODUCT_GROUP_TRANSLATIONS.REJECTED:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    default:
      return state;
  }
}
